import React, { useRef } from "react";

const projects = [
  {
    id: "fireex-site",
    title: "Fire EX",
    url: "https://fireex.pl",
    video: "https://trakz.com.pl/fireex_small.mp4",
    alt: "Fire EX Project",
  },
  {
    id: "diva-makeup",
    title: "Diva Makeup",
    url: "https://diva-makeup.pl",
    video: "https://trakz.com.pl/diva_makeup_small.mp4",
    alt: "Diva Makeup Project",
  },
  {
    id: "stachura-psycholog",
    title: "Stachura Psycholog",
    url: "https://stachurapsycholog.pl",
    video: "https://trakz.com.pl/stachura_small.mp4",
    alt: "Stachura Psycholog Project",
  },
  {
    id: "trakz-site",
    title: "Trakz",
    url: "https://trakz.com.pl",
    video: "/trakz_site.mp4",
    alt: "Trakz Project",
  },
];

const ProjectCard = ({ project }) => {
  const videoRef = useRef(null);

  const playPreview = () => {
    const video = videoRef.current;
    if (!video) return;

    video.currentTime = 0;
    video.play().catch(() => {});
  };

  const pausePreview = () => {
    const video = videoRef.current;
    if (!video) return;

    video.pause();
    video.currentTime = 0;
  };

  return (
    <div
      className={`project-card${project.image ? " has-poster" : ""}`}
      id={project.id}
      onMouseEnter={playPreview}
      onMouseLeave={pausePreview}
    >
      <div className="project-media">
        {project.image && <img src={project.image} alt={project.alt} />}
        <video
          ref={videoRef}
          src={project.video}
          muted
          loop
          playsInline
          preload="metadata"
          aria-label={project.alt}
        />
      </div>
      <a href={project.url} target="_blank" rel="noopener noreferrer">
        <h3>{project.title}</h3>
      </a>
    </div>
  );
};

const Projects = () => {
  return (
    <div className="portfolio-projects">
      <h2>Projects</h2>
      <div className="project-cards-wrapper">
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
